import { Component } from '@angular/core';

@Component({
    selector: 'ngx-footer',
    styleUrls: ['./footer.component.scss'],
    template: `
    <span class="w-100 text-center created-by">Created with ♥ by <b><a href="https://www.coddygames.com" target="_blank">Coddy</a></b></span>
  `,
    standalone: false
})
export class FooterComponent {
}
